import React, { useState } from 'react'
import { SessionManager } from "../services/SessionManager/SessionManager";
import GGModalWindow from '../components/UtilityComponents/GGModalWindow/GGModalWindow';
import { Box, TextField, Typography } from '@mui/material';
import GGButton from '../components/CommonComponents/GGButton/GGButton';
import { AdminAPIHandler } from '../services/NetworkClient/BackendAPIs/AdminAPIHandler';


type SellerRouteProps = {
    components: Array<any>;
};

// Allow access to only seller users who are logged in
const AdminRoute: React.FC<SellerRouteProps> = ({components}) => {

  const [adminPassword, setAdminPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [adminLoggedIn, setAdminLoggedIn] = useState(SessionManager.shared.isAdminLoggedin());

  const loginAdmin = async () => {
    try {
        await AdminAPIHandler.shared.login(adminPassword)
        setAdminLoggedIn(true)
    } catch (err: any) {
        setLoginError(err as string);
    }
    
  }

  return (<> { adminLoggedIn ? 
    (<> {components.map((Component, index) => <Component key={index} />)} </>) : 
    ( <GGModalWindow 
        
         childView={ 
            <Box sx={{display: 'flex', flexDirection: 'column', gap: '15px'}}> 
                <TextField helperText={ <Typography variant='caption' color={'error'}>{loginError}</Typography>} label={"Enter admin password"} variant="outlined" style={{ width: '100%' }} value={adminPassword} onChange={(e) => setAdminPassword(e.target.value)} />
                <GGButton onClick={loginAdmin}> Submit </GGButton>    
            </Box>
        }
         open={true} 
         title='Enter admin password' 
         onCloseHandler={() => {}} 
         width='500px'
      />)
    }
    </>) 
}

export default AdminRoute